'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CATEGORIES = _constantsAnalytics2.default.CATEGORIES,
    EVENTS = _constantsAnalytics2.default.EVENTS,
    ACTIONS = _constantsAnalytics2.default.ACTIONS,
    LABELS = _constantsAnalytics2.default.LABELS;


function composeFormatPickerExpandEvent(expand) {
  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(EVENTS.FORMAT_CHOOSER_SELECTION, {
    gtmCategory: CATEGORIES.BIB_FORMAT_CHOOSER,
    gtmAction: ACTIONS.INTERACT_WITH_CONTAINER,
    gtmLabel: expand ? LABELS.CONTAINER_EXPAND : LABELS.CONTAINER_COLLAPSE,
    gtmValue: 1
  })]);
}

function composeFormatPickerSelectionEvent(label) {
  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(EVENTS.FORMAT_CHOOSER_SELECTION, {
    gtmCategory: CATEGORIES.BIB_FORMAT_CHOOSER,
    gtmAction: ACTIONS.CLICK_LINK,
    gtmLabel: label,
    gtmValue: 1
  })]);
}

function composeFormatPickerViewAllEvent() {
  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(EVENTS.FORMAT_CHOOSER_SELECTION, {
    gtmCategory: CATEGORIES.BIB_FORMAT_CHOOSER,
    gtmAction: ACTIONS.INTERACT_WITH_CONTAINER,
    gtmLabel: LABELS.CONTAINER_VIEW_ALL,
    gtmValue: 1
  })]);
}

exports.default = {
  composeFormatPickerExpandEvent: composeFormatPickerExpandEvent,
  composeFormatPickerSelectionEvent: composeFormatPickerSelectionEvent,
  composeFormatPickerViewAllEvent: composeFormatPickerViewAllEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/bibFormatChooser.js
// module id = 575
// module chunks = 0 2 4 5 6 8 9 10 11